
// import { gsap } from 'gsap';
//  import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
//  gsap.registerPlugin(ScrollToPlugin);
import { debounce as _debounce } from 'underscore';
// import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import '@benmajor/jquery-touch-events';
// import 'jquery-clickout';

export default class{

    constructor( options ) {
        this.defaults = {
        	$el:                    false,
            active:                 true
        }
        this.options = {};
		Object.assign(this.options, this.defaults, options);
		this.namespace 		= 	'myemma_newsletter_form';
		this.$el 			= 	this.options.$el;
		this.main			=   this.options.main;

		if ( this.$el.length > 0 ){
			this.init();
		}
    }

    init(){
    	this.$html = $('html');
        this.$win  = $(window);
        this.$response  = this.$el.find( '.response' );
        this.$close     = this.$response.find( '.close' );
        this.$form      = this.$el.find( 'form' );
        this.$field     = this.$form.find('input[name="EMAIL"]');
        this.placeholder = (this.$field.attr('placeholder') || '');
        

    	this.addEvents( true );
	}

    log(str){
        console.log( this.namespace + ' :: ' + str );
    }

	//---------------------------------------- EVENTS ---------------------------------------//
	addEvents( b ){
		if ( b ){
    		if ( this.$html.hasClass( 'touch' ) ){
    			this.$close.on( 'tap', (e)=>this.open(false,e) );
    		}
    		else{
    			this.$close.on( 'click', (e)=>this.open(false,e) );
    		}
            this.$field.on( 'focus', (e)=>this.focus(true,e) );
            this.$field.on( 'blur', (e)=>this.focus(false,e) );
		}
		else{
    		if ( this.$html.hasClass( 'touch' ) ){
    			this.$close.off( 'tap', (e)=>this.open(false,e) );
    		}
    		else{
    			this.$close.off( 'click', (e)=>this.open(false,e) );
    		}
            this.$field.off( 'focus', (e)=>this.focus(true,e) );
            this.$field.off( 'blur', (e)=>this.focus(false,e) );
		}
        //this.debounceResize(b);
        this.ajaxifyForm(b);
	}

    debounceResize(b){
        if ( b ){
            // debounce resize
            this._debResize = _debounce( () => this.onResize(), 117 );
            this.$win.on( 'resize', this._debResize );
        }
        else{
            if ( this._debResize ){
                this._debResize.cancel();
                this.$win.off( 'resize', this._debResize );
            }        
        }
    }

    addClickOut(b){
        if ( b ){
            this.$response.on( 'clickout', (e)=>this.open(false,e) );
        }
        else{
            this.$response.off( 'clickout' ); //, (e)=>this.open(false,e) );
        }
    }

    onResize(){
    }


    validateEmail(){
        let $email = this.$form.find( 'input[type="email"]' );

        console.log( $email.val() );

        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test($email.val()) ){
            return true;
        }
        this.setResponse( 'You have entered an invalid email address.' );       
        return false;

    }

    ajaxifyForm(b){
        if ( this.$form.length <= 0){
            return;
        }
        if ( b ){

            this.$form.find('button[type="submit"]').on('click', (event)=>{
            // this.$form.on( 'submit', (event)=>{
                if (event) event.preventDefault();

                if ( this.options.active ){


                    // check email
                    if ( ! this.validateEmail() ){
                        return;
                    }



                    this.setLoading(true);

                    let data        = this.$form.serialize();
                    data += '&action=newsletter_subscribe';


                    console.log( data );

                    $.ajax({
                        type:           this.$form.attr('method'),
                        url:            this.$form.attr('action'),  
                        dataType:       'json',
                        //contentType:    'application/json; charset=utf-8',
                        data:           data,
                        cache:          false,
                        error: (err)=>{ 
                            
                            console.log( 'error' );
                            console.log( err );

                            this.setResponse( 'Could not connect. Please try again later.' );
                            this.setState( false );
                        },
                        success:(data)=>{

                            console.log( 'success' );
                            console.log( data );

                            if (data.status === 'success') {
                                // Yeahhhh Success
                                this.$field.val('');
                                this.setResponse( data.message );
                                this.setState( true );

                            } 
                            else{
                                // Something went wrong, do something to notify the user.
                                this.$field.val('');
                                this.setResponse( data.message );
                                this.setState( false );
                            }
                        }
                    })

                }
                else{
                    this.setResponse( 'This form is not active. <br/>Still missing myEmma secrets.' );
                }

            });
            /*
            $form.find('input[name="EMAIL"]').on( 'focus', function(){
            });
            */
        }
        else{
            this.$form.find('input[type="submit"]').off('click');
        }
    }

    setLoading(b){
        if ( this.main ){
            this.main.setLoading(b);
        }
        if ( b ){
            this.$el.addClass( 'processing' );
        }
        else{
            this.$el.removeClass( 'processing' );
        }
    }

    setResponse( response ){
        this.$response.find( '.message' ).html( response );
        let $a = this.$response.find( '.message a' );
        if ( $a.length > 0 ){
            $a.addClass( 'no-barba' ).attr('target', '_blank');
            $a.on( 'click', (e)=>{
                window.open( $(e.currentTarget).attr( 'href' ), '_blank');
            });
        }
        this.open( true );
        this.setLoading( false );
    }

    setState( b ){
        if ( b){
            this.state = 'SUBSCRIBED';
            // ok, subscribed. You get an email to confirm
            // response:: Thank you. Please check your email to confirm your subscription.
            this.$el.trigger( 'newsletter:subscribed' );

            this.sendGAEvent();
        }
        else{
            this.state = 'ERROR';
            // Given email address is already subscribed, thank you!
            // Please provide a valid email address.
            this.$el.trigger( 'newsletter:error' );
        }
        this.$el.trigger( 'newsletter:always' );
    }  

    sendGAEvent(){
        let location = '';
        if ( this.$el.parents( '#footer' ) || this.$el.parents( '#mobile-footer' ) ){
            location = 'footer';
        }
        /*
        else if ( this.$el.parents( '.overlay-message' ) ){
            location = 'home overlay';
        }
        else if ( this.$el.parents( '.module-promos-double' ) ){
            location = 'promo double';
        }
        */
        this.main.setGAEvent( 'Newsletter Signup', 'Newsletter Signup', location, document.location.href )
    }

    //---------------------------------------- METHODS ---------------------------------------//

    focus(b, e){
        if (b) {
            this.$field.removeAttr('placeholder');
        } else {
            this.$field.attr('placeholder', this.placeholder);            
        }
    }

    open(b){
        if(b){
            this.$response.addClass( 'active' );
            setTimeout( ()=>{
                this.addClickOut( true );
            }, 1000 );
        }
        else{
            this.addClickOut( false );
            this.$response.removeClass( 'active' );
            this.closeOverlayMessage();
        }
        this.$el.trigger( b ? 'newsletter:open' : 'newsletter:close' );
    }

    closeOverlayMessage(){
        let $o = this.$el.parents( '.overlay-message' );
        if ( this.state === 'SUBSCRIBED' && $o.length > 0 ){
            $o.find( '.close.icon' ).trigger( 'click' );
        }
    }

    destroy(){
		this.addEvents( false );
    }

}


